import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_AMENITIES_DETAILS, GET_AMENITIES_DETAILS_SUCCESS, GET_AMENITIES_DETAILS_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getAmenitiesDetails({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/get-amenities-flag`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        'Project-Code': 'ADMIN_ACCESS',
      },
      params: {
        ...payload?.urlParam,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: GET_AMENITIES_DETAILS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_AMENITIES_DETAILS_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_AMENITIES_DETAILS_ERROR, payload: error });
  }
}

export function* watchGetAmenitiesDetails() {
  yield takeEvery(GET_AMENITIES_DETAILS, getAmenitiesDetails);
}

function* getAmenitiesDetailsSaga() {
  yield all([fork(watchGetAmenitiesDetails)]);
}

export default getAmenitiesDetailsSaga;
